import { useContext } from 'react';
import { MessagesContext } from './context';

export const useMessages = () => {
  const context = useContext(MessagesContext);
  return context;
};
